// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de sciences
// https://ifpc-fwb.be/v5/documents/tc/refSCIENCES.pdf
// SHA-256 310d0d9138c340ee234ca55602e6ec7e342d0d48a4dabbfca90d3ffaf93fbfbc
// P3: pages 40-46, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "SCIENCES-P3-9ac7e853",
    champ: "",
    section: "Se questionner",
    kind: "",
    parent: "Se questionner, s’approprier un questionnement.",
    text: "Reformuler ensemble (élèves et/ou enseignant) les questions spontanées en question d’ordre scientifique.",
  },
  {
    id: "SCIENCES-P3-e341fa60",
    champ: "",
    section: "Se questionner",
    kind: "",
    parent: "Proposer des explications possibles d’un phénomène et/ou émettre une hypothèse.",
    text: "Proposer des explications et les confronter à celles des autres pour sélectionner des hypothèses à tester.",
  },
  {
    id: "SCIENCES-P3-2a09df10",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Proposer, adapter des moyens d’investigation.",
    text: "Explorer le sujet par essais/erreurs pour proposer ensemble (élèves et enseignant) des moyens d’investigation.",
  },
  {
    id: "SCIENCES-P3-2bfecf32",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Expérimenter et traiter les résultats.",
    text: "Suivre un protocole simple.",
  },
  {
    id: "SCIENCES-P3-e634ef49",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Expérimenter et traiter les résultats.",
    text: "Concevoir collectivement un protocole et le mettre en œuvre.",
  },
  {
    id: "SCIENCES-P3-0bdb0f70",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Expérimenter et traiter les résultats.",
    text: "Utiliser le matériel avec soin et respecter les consignes de sécurité.",
  },
  {
    id: "SCIENCES-P3-8fda17c5",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Expérimenter et traiter les résultats.",
    text: "Verbaliser et schématiser une situation expérimentale.",
  },
  {
    id: "SCIENCES-P3-9b6b4a25",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Observer.",
    text: "Réaliser une observation en lien avec la question d’ordre scientifique.",
  },
  {
    id: "SCIENCES-P3-3b93ea3a",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Consulter des documents et/ou des personnes.",
    text: "Recueillir des informations en lien avec une question d’ordre scientifique, à partir de différents supports (tableau de données, document audiovisuel, photo, croquis, texte…) et/ou auprès d’une personne-ressource.",
  },
  {
    id: "SCIENCES-P3-da90ee43",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Utiliser des représentations/des modèles scientifiques.",
    text: "Utiliser une représentation simplifiée pour comprendre une réalité complexe.",
  },
  {
    id: "SCIENCES-P3-231d4b28",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Analyser et débattre.",
    text: "Confronter ensemble (élèves et/ou enseignant) les informations et les résultats trouvés.",
  },
  {
    id: "SCIENCES-P3-e9ea97cc",
    champ: "",
    section: "Investiguer des pistes et garder des traces évolutives",
    kind: "",
    parent: "Faire évoluer les explications/ hypothèses.",
    text: "Confronter son explication de départ aux données récoltées.",
  },
  {
    id: "SCIENCES-P3-49ebedd6",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Faire évoluer les explications/ hypothèses.",
    text: "Rassembler collectivement les informations et les résultats obtenus.",
  },
  {
    id: "SCIENCES-P3-b25b04bf",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Structurer des informations sous une forme qui favorise la compréhension.",
    text: "Identifier la cause et l’effet.",
  },
  {
    id: "SCIENCES-P3-bc2adefd",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Structurer des informations sous une forme qui favorise la compréhension.",
    text: "Confronter ensemble les informations et les résultats trouvés à la question et aux hypothèses de départ.",
  },
  {
    id: "SCIENCES-P3-742fc1a4",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Vérifier si la question de départ et la réponse sont concordantes, puis valider les résultats.",
    text: "Répondre à la question de départ, en s’appuyant sur les faits, les données, les résultats et les discussions issus de la démarche d’investigation.",
  },
  {
    id: "SCIENCES-P3-d5536a73",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Synthétiser.",
    text: "Construire ensemble une synthèse des concepts qui ont été appris.",
  },
  {
    id: "SCIENCES-P3-e4014047",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "",
    parent: "Communiquer sur les résultats, les connaissances acquises et la démarche mise en œuvre.",
    text: "Réaliser une trace, en utilisant le support le plus adéquat (dessin, maquette, photo, panneau, présentation orale filmée...).",
  },
  {
    id: "SCIENCES-P3-51c4b72a",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Communiquer sur les résultats, les connaissances acquises et la démarche mise en œuvre.",
    text: "Identifier les parties de la plante à fleurs dont, au moins, la graine, la tige, la racine, la feuille, le fruit et la fleur.",
  },
  {
    id: "SCIENCES-P3-69081b58",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Anatomie des plantes à fleurs - Fruit - Tige - Racine - Feuille - Graine - Fleur",
    text: "Préciser que les graines sont contenues dans un fruit.",
  },
  {
    id: "SCIENCES-P3-93cfef99",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Anatomie des plantes à fleurs - Fruit - Tige - Racine - Feuille - Graine - Fleur",
    text: "Expliquer que la germination d’une graine dépend de certaines conditions (humidité, température adéquate et présence d’air).",
  },
  {
    id: "SCIENCES-P3-a154e001",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Facteurs nécessaires à la germination d’une plante - Humidité - Température adéquate - Air",
    text: "Nommer des besoins essentiels à la croissance d’une plante : eau, air, lumière.",
  },
  {
    id: "SCIENCES-P3-95ae3882",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Croissance de la plante",
    text: "Énoncer que la plante fabrique de la matière : elle grandit, fabrique des feuilles, des fleurs…",
  },
  {
    id: "SCIENCES-P3-59efb45b",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Arbres et plantes de l’environnement proche",
    text: "Citer des plantes peuplant l’environnement proche (arbres, arbustes, plantes…).",
  },
  {
    id: "SCIENCES-P3-eac17aeb",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir",
    parent: "Vocabulaire",
    text: "Utiliser les termes : graine, tige, racine, feuille, fruit, fleur, plante à fleurs, humidité, air, eau, lumière.",
  },
  {
    id: "SCIENCES-P3-50db14ec",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir-faire",
    parent: "Vocabulaire",
    text: "Réaliser des semis pour déterminer des conditions pour qu’une graine germe.",
  },
  {
    id: "SCIENCES-P3-94534f2d",
    champ: "",
    section: "Structurer les résultats, les valider, les synthétiser et communiquer",
    kind: "Savoir-faire",
    parent: "Réaliser une observation en lien avec la question d’ordre scientifique : les plantes à fleurs.",
    text: "Choisir les critères d’observation et recueillir des informations en lien avec les étapes de la vie d’une plante à fleurs.",
  },
  {
    id: "SCIENCES-P3-6cd61694",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Compétence",
    parent: "Pratiquer des démarches d’investigation scientifique : la germination d’une graine et la croissance d’une plante.",
    text: "Pratiquer une démarche d’investigation scientifique pour déterminer les conditions nécessaires pour qu’une plante se développe à partir d’une graine.",
  },
  {
    id: "SCIENCES-P3-e35d730f",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Caractéristiques de l’eau liquide - Inodore, incolore, transparente",
    text: "Nommer les caractéristiques physiques de l’eau à l’état liquide : incolore, inodore, transparente.",
  },
  {
    id: "SCIENCES-P3-eef8f63a",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Mélanges",
    text: "Préciser qu’un mélange est une association de plusieurs matières.",
  },
  {
    id: "SCIENCES-P3-dc657810",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Mélanges",
    text: "Préciser que les eaux usées sont des mélanges.",
  },
  {
    id: "SCIENCES-P3-414f317f",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Mélanges",
    text: "Préciser la provenance de l’eau du robinet.",
  },
  {
    id: "SCIENCES-P3-42e3f435",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Identifier la station de captage comme le lieu permettant de capter l’eau du sol.",
  },
  {
    id: "SCIENCES-P3-3909fe1c",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Identifier la station d’épuration comme le lieu permettant d’épurer l’eau.",
  },
  {
    id: "SCIENCES-P3-dfc12e82",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Identifier le château d’eau comme étant un élément participant au stockage et à la distribution de l’eau potable dans les maisons.",
  },
  {
    id: "SCIENCES-P3-83abc8df",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Citer les usages quotidiens de l’eau pour subvenir à nos besoins.",
  },
  {
    id: "SCIENCES-P3-6f40b657",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Associer de l’eau potable à de l’eau que l’on peut boire et l’eau non potable à de l’eau que l’on ne doit pas boire.",
  },
  {
    id: "SCIENCES-P3-04e096f7",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Origine de l’eau potable et devenir des eaux usées - Station de captage - Station d’épuration - Château d’eau (vases communicants) - Usages de l’eau",
    text: "Énoncer la nécessité de traitement des eaux usées avant le rejet dans l’environnement.",
  },
  {
    id: "SCIENCES-P3-e4261138",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir",
    parent: "Vocabulaire",
    text: "Utiliser les termes : inodore, incolore, transparent, eaux usées, eau potable, station d’épuration, mélange, station de captage, château d’eau.",
  },
  {
    id: "SCIENCES-P3-ab026705",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir-faire",
    parent: "Réaliser une observation en lien avec la question d’ordre scientifique : l’eau potable.",
    text: "Comparer différentes eaux rencontrées : eau de distribution, eau de pluie, eau de mer, eau en bouteille, eaux usées…",
  },
  {
    id: "SCIENCES-P3-bb74f398",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir-faire",
    parent: "Recueillir des informations en lien avec une question d’ordre scientifique, à partir de différents supports, observations et/ou auprès d’une personne-ressource : la consommation de l’eau.",
    text: "Estimer et comparer la consommation d’eau de différentes activités au sein de l’école (ex. : se laver les mains, faire la vaisselle, tirer la chasse…). Repérer certains usages domestiques pour lesquels il est possible d’utiliser de l’eau de pluie plutôt que de l’eau potable.",
  },
  {
    id: "SCIENCES-P3-b4f8432c",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir-faire",
    parent: "Utiliser une représentation simplifiée pour comprendre une réalité complexe : l’origine de l’eau potable et le devenir des eaux usées.",
    text: "Représenter le chemin de l’eau, depuis l’eau potable jusqu’à l’eau usée, et inversement",
  },
  {
    id: "SCIENCES-P3-83d86723",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir-faire",
    parent: "Imaginer et réaliser une expérience simple : les vases communicants (le château d’eau).",
    text: "Imaginer et réaliser une expérience simple permettant de comprendre le fonctionnement du château d’eau.",
  },
  {
    id: "SCIENCES-P3-7a2211f1",
    champ: "",
    section: "Visée 1 « Pratiquer des sciences »",
    kind: "Savoir-faire",
    parent: "Poser un choix et agir.",
    text: "Proposer quelques gestes pour économiser l’eau.",
  },
  {
    id: "SCIENCES-P3-33cb5390",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Compétence",
    parent: "Développer une aptitude à mettre en relation des choix et des actions avec des connaissances scientifiques : les ressources en eau.",
    text: "Mettre en évidence des impacts de notre mode de vie sur la gestion de l’eau et énoncer des gestes et des actions permettant de préserver les ressources en eau.",
  },
  {
    id: "SCIENCES-P3-24971efd",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Perception de son environnement - Sens : la vue, l’ouïe, le toucher, l’odorat, le gout - Organes des sens : l’œil, l’oreille, la peau, le nez, la langue - Cerveau - Nerfs",
    text: "Associer les sens aux organes des sens.",
  },
  {
    id: "SCIENCES-P3-582c13db",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Perception de son environnement - Sens : la vue, l’ouïe, le toucher, l’odorat, le gout - Organes des sens : l’œil, l’oreille, la peau, le nez, la langue - Cerveau - Nerfs",
    text: "Identifier le cerveau comme un organe permettant de traiter des informations.",
  },
  {
    id: "SCIENCES-P3-cb148abd",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Perception de son environnement - Sens : la vue, l’ouïe, le toucher, l’odorat, le gout - Organes des sens : l’œil, l’oreille, la peau, le nez, la langue - Cerveau - Nerfs",
    text: "Identifier les nerfs comme des moyens de transporter des informations.",
  },
  {
    id: "SCIENCES-P3-63ae071c",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Son - Production - Propagation - Réception - Réflexion/absorption",
    text: "Identifier qu’un son est une vibration qui se propage dans une matière et qui peut être : - émise par une source de son ; - captée par un récepteur ; - perçue différemment en fonction de la distance par rapport à l’émetteur ; - renvoyée par des objets ; - arrêtée ou non par des matériaux.",
  },
  {
    id: "SCIENCES-P3-b7e97608",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Son - Production - Propagation - Réception - Réflexion/absorption",
    text: "Énoncer que l’oreille est un récepteur de son et que le cerveau traite les informations en provenance de celle-ci.",
  },
  {
    id: "SCIENCES-P3-43e78c2d",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Caractéristiques d’un son - Intensité : fort, faible - Hauteur : aigu, grave",
    text: "Qualifier un son de fort, faible, aigu, grave.",
  },
  {
    id: "SCIENCES-P3-14d6fee4",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Dangers liés aux sons",
    text: "Citer des comportements de protection face aux dangers liés aux sons trop forts.",
  },
  {
    id: "SCIENCES-P3-4af21e19",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Lumière - Production - Propagation en ligne droite - Réception - Réflexion/absorption",
    text: "Préciser que la lumière est : - émise par une source de lumière ; - captée par un récepteur ; - renvoyée par des objets ; - arrêtée ou non par des matériaux.",
  },
  {
    id: "SCIENCES-P3-fb049fba",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Lumière - Production - Propagation en ligne droite - Réception - Réflexion/absorption",
    text: "Énoncer que l’œil est un récepteur de lumière et que le cerveau traite les informations en provenance de celui-ci.",
  },
  {
    id: "SCIENCES-P3-ef59a118",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Lumière - Production - Propagation en ligne droite - Réception - Réflexion/absorption",
    text: "Distinguer une source de lumière d’un objet éclairé.",
  },
  {
    id: "SCIENCES-P3-8a15a90b",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Lumière - Production - Propagation en ligne droite - Réception - Réflexion/absorption",
    text: "Décrire le trajet de la lumière permettant de voir un objet, en précisant que la lumière se propage en ligne droite.",
  },
  {
    id: "SCIENCES-P3-ce200370",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Lumière - Production - Propagation en ligne droite - Réception - Réflexion/absorption",
    text: "Citer différentes sources de lumière.",
  },
  {
    id: "SCIENCES-P3-694b4be4",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Caractéristiques de la lumière - Intensité : forte, faible - Couleur : blanche ou colorée",
    text: "Préciser qu’une lumière peut être forte ou faible, blanche ou colorée.",
  },
  {
    id: "SCIENCES-P3-f19d1acf",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Instruments d’optique",
    text: "Préciser le rôle et l’usage d’instruments d’optique courants (ex. : miroirs, loupes, lunettes, jumelles…).",
  },
  {
    id: "SCIENCES-P3-a2aacd30",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Dangers liés à la lumière",
    text: "Citer des comportements de protection face aux dangers liés à la lumière trop intense et à l’usage de rayons LASER.",
  },
  {
    id: "SCIENCES-P3-8fbd8563",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir",
    parent: "Vocabulaire",
    text: "Utiliser les termes : son, vibration, lumière, couleur, vue, ouïe, toucher, odorat, gout, cerveau, nerf, source, récepteur.",
  },
  {
    id: "SCIENCES-P3-9ece733d",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir-faire",
    parent: "Réaliser une observation en lien avec la question d’ordre scientifique : les appareils émettant du son/de la lumière.",
    text: "Repérer des appareils qui émettent du son et/ou de la lumière, dans le cadre de dispositifs de sécurité (ex. : alarme incendie ou de sécurité, sirène des pompiers, panneaux de sécurité, phares…).",
  },
  {
    id: "SCIENCES-P3-51d08342",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir-faire",
    parent: "Suivre un protocole simple ou concevoir collectivement un protocole et le mettre en œuvre : la perception du son et de la lumière.",
    text: "Montrer expérimentalement que le son et la lumière peuvent changer de direction et/ou être atténués, lorsqu’ils rencontrent certains obstacles (ex. : bouchons d’oreilles, casques, panneaux antibruit, lunettes de protection, miroirs…).",
  },
  {
    id: "SCIENCES-P3-35c256ee",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir-faire",
    parent: "Repérer des informations pour poser un choix et se protéger en ce qui concerne l’exposition aux sons et la lumière.",
    text: "Repérer des situations dans lesquelles le son est trop intense et énumérer un ensemble de précautions à prendre pour s’en protéger.",
  },
  {
    id: "SCIENCES-P3-f94fbe86",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir-faire",
    parent: "Confronter les informations obtenues avec celles des autres : la protection face au bruit et à la lumière trop intenses.",
    text: "Repérer des situations où la lumière est trop intense et énumérer un ensemble de précautions à prendre pour s’en protéger.",
  },
  {
    id: "SCIENCES-P3-c02db31a",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Savoir-faire",
    parent: "Poser un choix et agir.",
    text: "Énumérer des moyens pour être vu et/ou entendu et pour percevoir son environnement (ex. : à vélo…).",
  },
  {
    id: "SCIENCES-P3-867d7c68",
    champ: "",
    section: "Visée 4 « Orienter ses choix et agir en s’appuyant sur les sciences »",
    kind: "Compétence",
    parent: "Développer une aptitude à mettre en relation des choix et des actions avec des connaissances scientifiques : le son et la lumière.",
    text: "Proposer et expliquer des comportements appropriés pour se protéger, en établissant un lien avec le son/la lumière et les organes qui les perçoivent.",
  },
];
